<template>
  <div>
    <a-spin :spinning="isloading" tip="加载中...">
      <div class>
       
        <div class="mainWrapper clearfix">
          <div class="articleMeauleft">
            <a-divider orientation="left">课程分类</a-divider>
            <a-tree
            :replaceFields="replaceFields"
            :treeData="classList"
            @select="this.onSelect"
            @check="this.onCheck"/>
          
          </div>
          <div class="articleMainRight">
            <div class="pxkeji-right-box" style="margin-top:0">
               <a-form class="ant-advanced-search-form">
                  <a-row :gutter="24">
                    <a-col :span="8">
                      <a-form-item label="课程名称">
                        <a-input placeholder="请输入" v-model="where.keyword.courseName" />
                      </a-form-item>
                    </a-col>
                  
                    <a-col :span="16" :style="{ textAlign: 'left' }">
                      <a-button type="primary" @click="searchList">搜索</a-button>
                    </a-col>
                  </a-row>
                </a-form>
              <a-table
                :columns="list.columns"
                rowKey="id"
                :pagination="list.pagination"
                @change="onChange"
                :dataSource="list.datas"
                :loading="isloading"
                :rowSelection="{type:'checkbox',onChange:onRowChange,selectedRowKeys:selectRows,getCheckboxProps:getCheckboxProps}"
                :locale="{emptyText:'暂无数据'}"
              >
                <span slot="status" slot-scope="status">
                  <a-tag v-if="status==0" color="blue">未发布</a-tag>
                  <a-tag v-else-if="status==1" color="green">进行中</a-tag>
                  <a-tag v-else color="red">已结束</a-tag>
                </span>
                <span slot="action" slot-scope="info">
                  <pxkeji-btn name="编辑" :roles="[]" size="small" @click="showInfo(info)" type="primary" />
                  <a-divider type="vertical" />
                  <pxkeji-btn
                    name="删除"
                    :roles="[]"
                    size="small"
                    @click="delInfo(info.id)"
                    type="default"
                  />
                </span>
              </a-table>
               <a-button type="primary" :style="{ margin:'10px'}" @click="choseBack">选择并返回</a-button>
            </div>
          </div>
        </div>
        
      </div>
    </a-spin>
  </div>
</template>

<script>
var that;
const columns = [
  {
    dataIndex: "id",
    key: "id",
    align: "center",
    title: "课程编号"
  },
  {
    dataIndex: "name",
    key: "name",
    align: "center",
    title: "课程名称"
  },

];
export default {
  props: {
    ids: Array,
  },
  data() {
    return {
      classList: [],
      replaceFields: { children: "children", title: "name", key: "id" },
      list: {
        columns, //表头
        datas: [], //数据
        pagination: {
          //分页器
          showQuickJumper: true,
          hideOnSinglePage: true,
          total: 0,
          current: 1, //页码
          defaultPageSize: 10 //页容
        }
      },
      where: {
        //查询条件
        keyword: {
          //搜索条件
          courseName: "",
          typeId:null,
        }
      },
      allSelectRows: [],
      selectRows: [], //选中项编号
      isloading: false
    };
  },
  mounted() {
    this.$nextTick(() => {
      that=this;
      this.allSelectRows=this.ids?this.ids:[];
      this.getType();
      this.GetList();
    });
  },
  methods: {
    getCheckboxProps(record){
        var checked=false;
        for(var i in that.allSelectRows){
          if(that.allSelectRows[i]==record.id){
            checked=true; 
            that.selectRows.push(that.allSelectRows[i])
            break;
          }
        }

        return {
          props:{
            defaultChecked:checked,
            disabled:checked
          },
        }
    },
    onCheck(checkedKeys, info){

    },
    onSelect(selectedKeys, info) {
      that.where.keyword.typeId = selectedKeys[0];
      this.GetList();
    },
  
    getType(){
      this.isloading = true;
      this.$api.courseType
        .getTreeByColumnId('', '')
        .then(res => {
          this.isloading = false;
          if (res.errorCode == this.$msg.responseCode.success) {
            this.classList = res.data;
          } else {
            that.$message.error(res.errorMsg);
          }
        })
        .catch(() => {
          this.isloading = false;
        });
    },
    GetList() {
      this.isloading = true;
      this.clearRows();
      this.$api.course
        .getPageList(
          this.list.pagination.current,
          this.list.pagination.defaultPageSize,
          this.where.keyword.typeId,
          this.where.keyword.courseName,
          null,
          0,
          1
        )
        .then(res => {
          this.isloading = false;
          if (res.errorCode == this.$msg.responseCode.success) {
            this.list.datas = res.data.records;
            this.list.pagination.total = Number(res.data.total);
            
          } else {
            this.$message.error(res.errorMsg);
          }
        })
        .catch(() => {
          this.isloading = false;
        });
    },
    onChange(page) {
      //页面切换回调
      this.list.pagination.current = page.current;
      this.GetList();
    },
    onRowChange(selectedRowKeys) {
      this.selectRows = selectedRowKeys;
      for(var i in that.list.datas){
        if(selectedRowKeys.indexOf(that.list.datas[i].id)!=-1){
          //选中
            var find=false;
            for(var sel in that.allSelectRows){
              if(that.allSelectRows[sel]==that.list.datas[i].id){
                find=true;
                break;
              }
            }

            if(!find){
              that.allSelectRows.push(that.list.datas[i].id);
            }
        }else {
          for(var sel in that.allSelectRows){
           if(that.allSelectRows[sel]==that.list.datas[i].id){
              that.allSelectRows.splice(sel,1);
              break;
            }
          }
        }
      }
    },
    clearRows() {
      //清空选中项
      this.selectRows = [];
    },
    searchList() {
      for(var key in this.allSelectRows){
        delete this.allSelectRows[key];
      }
      this.list.pagination.current = 1;
      this.GetList();
    },
    clear() {
      //清空搜索条件
      for (var info in this.where.keyword) {
        this.where.keyword[info] = "";
      }
    },
    //选择并返回
    choseBack() {
      if(this.allSelectRows.length==0){
        this.$emit("callbackMethod", null,this.where.keyword.typeId);
        return ;
      }
      this.$emit("callbackMethod", this.allSelectRows.join(","),null);
    }
  }
};
</script>
<style>
.mainWrapper {
  box-sizing: border-box !important;
}
.articleMeauleft {
  width: 20%;
  padding: 0 1%;
  min-height: 700px;
  background: #fff;
  float: left;
  margin-top: 24px;
}
.articleMainRight {
  width: 80%;
  float: right;
}
.courseClass {
  padding-left: 10px;
}
.courseClass span {
  font-size: 14px;
  line-height: 2.5;
  cursor: pointer;
}
</style>